import PropTypes from 'prop-types';
import React from 'react';
import { injectIntl, intlShape } from 'react-intl';
import { FormBuilder } from 'shared-components/forms/form';
import { Avatar } from 'shared-components/image/avatar';

export const InboxMessageTextArea = injectIntl(
  ({
    avatarId,
    metaData,
    actionFn,
    actionCb,
    disabled,
    isDisableSpinning,
    msgError,
    btnColSize,
    displayResponsiveness,
    afterCTA,
    intl
  }) => {
    return (
      <div
        className='flex'
        data-testing-id='message-textarea-container'
      >
        <div className='message-panel-avatar-wrap'>
          <Avatar id={avatarId} />
        </div>
        <div id='msgTextArea' className='text-right flex-one'>
          <FormBuilder
            formname='msgform'
            formStyle='standard'
            formInputs={metaData}
            submitAction={actionFn}
            submitCallback={actionCb}
            isButtonDisabled={disabled}
            isDisableSpinning={isDisableSpinning}
            buttonText={intl.formatMessage({
              id: 'inbox.message_text_area.send',
              defaultMessage: 'Send Message'
            })}
            buttonClass='btn btn-secondary send-message-btn margin-lg-top'
            errorText={msgError}
            btnColSize={btnColSize}
            beforeCTA={displayResponsiveness()}
            afterCTA={afterCTA}
            useBootstrapGrid={false}
          />
        </div>
      </div>
    );
  }
);

InboxMessageTextArea.propTypes = {
  metaData: PropTypes.array,
  actionFn: PropTypes.func,
  actionCb: PropTypes.func,
  disabled: PropTypes.bool,
  isDisableSpinning: PropTypes.bool,
  msgError: PropTypes.string,
  btnColSize: PropTypes.string,
  afterCTA: PropTypes.object,
  avatarId: PropTypes.string,
  displayResponsiveness: PropTypes.func,
  intl: intlShape
};
